import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalTitle } from "src/components/Modals/Components/ModalsComponents";
import AddCommentField from "src/components/NewComponents/Exam/OptionDetails/Comments/AddCommentField";
import { ShortLimitedAccess } from "src/components/NewComponents/LimitedAccess";
import DefaultModal from "src/components/NewComponents/Modals/DefaultModal";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import { useAddForumComment } from "src/hooks/useComments";
import QuestionIcon from "src/images/Icons/newIcons/question.svg";

interface AddQuestionModalProps {
	onClose: () => void;
	options: Record<string, unknown>;
}

export function AddQuestionModal({ onClose, options }: AddQuestionModalProps) {
	const [commentImage, setCommentImage] = useState(null);
	const { mutateAsync } = useAddForumComment() as unknown as { mutateAsync: (params: Record<string, unknown>) => Promise<unknown> };
	const { t } = useTranslation();
	const onSubmit = async (value: string) => {
		await mutateAsync({
			comment: value,
			image: commentImage,
			options,
		});
		onClose();
	};

	if (hasLimitedAccess()) {
		return (
			<DefaultModal onClose={onClose} skipActions fullWidth>
				<div className="flex flex-col gap-32 w-100">
					<ModalTitle Icon={QuestionIcon} title={t("news.buttons.addQuestion")} />
					<ShortLimitedAccess />
				</div>
			</DefaultModal>
		);
	}

	return (
		<DefaultModal onClose={onClose} skipActions fullWidth>
			<div className="flex flex-col gap-32 w-100">
				<ModalTitle Icon={QuestionIcon} title={t("news.buttons.addQuestion")} />
				<AddCommentField
					onSubmit={onSubmit}
					placeholder="Wpisz treść pytania"
					submitText={t("news.buttons.addQuestion")}
					commentImage={commentImage}
					setCommentImage={setCommentImage}
					className=""
					parent={null}
				/>
			</div>
		</DefaultModal>
	);
}
